// eslint-disable-next-line import/prefer-default-export
export const initialStateProfile = {
  profile: {},
  isEditing: false,
  isLoading: false,
};
